import { StandFooterModule } from './../stand/components/footer/stand-footer.module';
import { NgModule } from '@angular/core';
import { StandFreeComponent } from './stand-free.component';
import { StandFreeRoutingModule } from './stand-free-routing.module';

@NgModule({
    imports: [
    StandFreeRoutingModule,
    StandFooterModule,
    StandFreeComponent
]
})
export class StandFreeModule { }
